import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'demo/store/auth/userSlice'
import { apiSignIn, apiSignOut, apiSignUp } from 'demo/services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'demo/store/auth/sessionSlice'
import appConfig from 'demo/configs/app.config'
import { REDIRECT_URL_KEY } from 'demo/constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { useEffect } from 'react'
import { getRole, getToken, getUsername } from 'demo/store/commonReducer'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, username } = useSelector((state) => state.common)

    const signIn = async (values) => {
        try {
            const resp = await apiSignIn(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                localStorage.setItem('token')
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        await apiSignOut()
        handleSignOut()
    }

    useEffect(() => {
        dispatch(getToken())
        dispatch(getUsername())
        dispatch(getRole())
    }, [])

    return {
        authenticated: token && username ? true : false,
        signIn,
        signUp,
        signOut,
    }
}

export default useAuth
